function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("title", null, "showPolygons");

function SvgShowPolygons(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), _ref, React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, React.createElement("rect", {
    width: 32,
    height: 32,
    style: {
      fill: "#fff"
    }
  }), React.createElement("line", {
    x1: 8.88,
    y1: 21,
    x2: 23.26,
    y2: 21,
    style: {
      fill: "none",
      stroke: "#636569",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), React.createElement("rect", {
    x: 18.14,
    y: 11.5,
    width: 3,
    height: 3,
    style: {
      fill: "#636569"
    }
  }), React.createElement("rect", {
    x: 6.86,
    y: 19.5,
    width: 3,
    height: 3,
    style: {
      fill: "#636569"
    }
  }), React.createElement("rect", {
    x: 11.86,
    y: 11.5,
    width: 3,
    height: 3,
    style: {
      fill: "#636569"
    }
  }), React.createElement("rect", {
    x: 22.14,
    y: 19.5,
    width: 3,
    height: 3,
    style: {
      fill: "#636569"
    }
  }), React.createElement("line", {
    x1: 8.88,
    y1: 21,
    x2: 13.36,
    y2: 13,
    style: {
      fill: "none",
      stroke: "#636569",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), React.createElement("line", {
    x1: 13.36,
    y1: 13,
    x2: 19.64,
    y2: 13,
    style: {
      fill: "none",
      stroke: "#636569",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), React.createElement("line", {
    x1: 19.64,
    y1: 13,
    x2: 23.64,
    y2: 21,
    style: {
      fill: "none",
      stroke: "#636569",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}

export default __webpack_public_path__ + "static/media/showPolygons.2cad4dc1.svg";
export { SvgShowPolygons as ReactComponent };